<template>
  <div class="view-container">
    <!-- Show spash screen -->
    <div v-if="showLoader">
      <app-loader :fadeoutLoader="fadeoutLoader"></app-loader>
    </div>
    <div v-if="fadeoutLoader"></div>
    <div class="menu-container">
      <!-- Begin: Departments -->
      <div class="categories-container">
        <div id="menu-categories" class="menu-categories">
          <!-- Inline to remove pixel spacings between items -->
          <div
            v-for="subDepartment in subDepartments"
            :key="subDepartment.departmentID"
            :data-id="subDepartment.departmentID"
            class="menu-category"
          >
            <i :class="'fa fa-' + subDepartment.icon"></i>
            <h6>{{ subDepartment.name }}</h6>
          </div>
        </div>
      </div>
      <!-- End: Departments -->
      <!-- Begin: Products -->
      <div
        v-for="department in subDepartments"
        :key="department.departmentID"
        class="menuItems col-lg-12"
      >
        <div
          class="product-category col-lg-12"
          :data-category-id="department.departmentID"
        >
          <span>{{ department.name }}</span>
        </div>

        <div
          v-for="product in products.filter(function (item) {
            if (item.subDepartmentID == department.departmentID) return true;
            return false;
          })"
          :key="product.id"
          class="menuItem col-lg-6"
          style="display: inline-grid"
          :data-id="product.id"
          :data-category-id="product.subDepartmentID"
        >
          <div
            v-if="product.imageURL"
            class="img-container"
            :style="'background-image: url(' + product.imageURL + ');'"
          ></div>
          <div v-else class="img-container empty"></div>
          <div class="details-container">
            <span class="item-name">{{ product.name }}</span>
            <div class="description-container">
              <span>{{ product.description }}</span>
            </div>
            <span class="item-price">{{ product.price.toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <!-- End: Products -->
    </div>
    <menuItemModal ref="menuItemModal"></menuItemModal>
  </div>
</template>
<!-- Scripts -->
<script>
import loaderPartial from '@/components/LoaderPartial.vue';
import { splashScreen } from '@/mixins/splashScreen';
import { view } from './Menu.vue.js';
import MenuItemModal from './MenuItemModal.vue';

export default {
  name: 'Menu',
  components: {
    'app-loader': loaderPartial,
    menuItemModal: MenuItemModal,
  },
  mixins: [splashScreen, view],
  data() {
    return {
      franchise: this.$route.query.franchise,
      franchiseID: this.$route.query.franchiseID,
      branchID: this.$route.query.branchID,
      clear: this.$route.query.clear,
      departments: [],
      subDepartments: [],
      products: [],
    };
  },
  params: {
    clear: false,
  },
  computed: {
    accentColor: function () {
      return this.$franchiseAccentColor;
    },
  },
  created() {
    var _self = this;

    if (_self.clear) {
      _self.$isTab = null;
      _self.$tableNo = null;
    }

    if (
      (this.franchise || this.franchiseID) &&
      _self.isStringNullOrEmpty(_self.$franchiseID)
    ) {
      if (this.franchise) _self.showSplashScreen();

      var franchiseData = {
        FranchiseID: this.franchiseID,
        FranchiseName: this.franchise,
      };
      _self.$ooApi.orders.franchises.get
        .v1(franchiseData)
        .then(function (result) {
          _self.$franchiseID = result.data.id;
          _self.$franchiseName = result.data.name;
          _self.$franchiseUrlFriendlyOrderName =
            result.data.urlFriendlyOrderName;
          _self.$franchiseLogoUrl = result.data.franchiseLogoURL;
          _self.$franchiseBannerUrl = result.data.bannerImageURL;
          _self.$franchiseAccentColor = result.data.accentColor;
          _self.$lastSessionDate = new Date();

          if (_self.branchID) _self.$branchID = _self.branchID;

          _self.initOoApi(_self.$franchiseID);
          _self.initPayApi(_self.$franchiseID);
          _self.loadMenus().then(() => _self.hideSplashScreen());
        });
    } else if (_self.isStringNullOrEmpty(_self.$franchiseID)) {
      _self.$router.push('Franchise');
    } else {
      _self.loadMenus().then(() => _self.hideSplashScreen());
    }

    window.addEventListener('scroll', function () {
      var menuCategories = document.querySelector('.categories-container');
      var menuContiner = document.querySelector('.menu-container');

      if (!menuCategories) return;

      var isPositionFixed = menuCategories.style.position == 'fixed';
      var bannerHeight = 400;

      if (screen.width < 767) bannerHeight = 210;
      if (
        document.scrollingElement.scrollTop > bannerHeight &&
        !isPositionFixed
      ) {
        menuCategories.style.position = 'fixed';
        menuCategories.style.top = '52px';
        menuContiner.style.marginTop = '52px';
      }
      if (
        document.scrollingElement.scrollTop < bannerHeight &&
        isPositionFixed
      ) {
        menuCategories.style.position = 'relative';
        menuCategories.style.top = '0px';
        menuContiner.style.marginTop = '0px';
      }
    });
  },
  updated() {
    this.resizeCategories();
  },
  methods: {
    loadMenus: function () {
      var _self = this;

      return new Promise((resolve, reject) => {
        var menuItemData = {
          FranchiseID: localStorage.franchiseID,
          FranchiseName: localStorage.franchiseName,
        };
        _self.$ooApi.orders.menu.items
          .v1(menuItemData)
          .then(function (result) {
            _self.departments = result.data.departments;
            _self.subDepartments = result.data.subDepartments;
            _self.products = result.data.products;
          })
          .then(function () {
            document
              .querySelectorAll('.menu-categories .menu-category')
              .forEach((item) => {
                item.addEventListener('mouseover', function (e) {
                  var target = e.currentTarget;
                  target.style.backgroundColor = _self.accentColor;
                  target.style.color = '#fff';
                  target.style.cursor = 'pointer';
                  target.querySelectorAll('i').forEach((subItem) => {
                    subItem.style.color = '#fff';
                  });
                });
                item.addEventListener('mouseout', function (e) {
                  var target = e.currentTarget;
                  if (!target.classList.contains('active-category')) {
                    target.style.backgroundColor = 'transparent';
                    target.style.color = '#000';
                    target.querySelectorAll('i').forEach((subItem) => {
                      subItem.style.color = '#000';
                    });
                  }
                });
                item.addEventListener('click', function (e) {
                  var target = e.currentTarget;
                  target.style.backgroundColor = _self.accentColor;
                  target.style.color = '#fff';
                  target.querySelectorAll('i').forEach((subItem) => {
                    subItem.style.color = '#fff';
                  });
                  _self.selectMenuCategory(e);
                });
              });
            document.querySelectorAll('.menuItem').forEach((item) => {
              item.addEventListener('click', _self.selectItem);
            });
            resolve();
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
  },
};
</script>
<style scoped>
@import './Menu.vue.css';

.overflow-hidden {
  overflow: hidden;
}
</style>
